<template>
  <div>
    <div class="card request-card mx-auto shadow-sm" style="max-width: 400px;">
      <div class="card-body">
        <div class="d-flex justify-content-between">
          <h3
            class="mb-3 text-break inline-block d-flex flex-wrap align-items-center"
          >
            <span class="text-nowrap mr-2">
              {{ app.title }}
            </span>
            <small class="text-muted text-nowrap">Request Access</small>
          </h3>
          <div class="ml-3">
            <EnvBadge class="ml-auto" :env="app.environment"></EnvBadge>
          </div>
        </div>

        <p style="font-weight: 500;">
          Access must be granted in order to use this application.
        </p>
        <p>
          Application administrators will be notified of your request, and you
          will receive an email notification upon approval.
        </p>
        <p>
          Applications can be accessed from the
          <a href="https://portal.fso.arizona.edu/"> Portal.</a>
        </p>

        <router-link
          :to="app.environment === 'prod' ? '/' : '/all'"
          class="btn btn-light mr-2"
          aria-label="Go back"
        >
          <ArrowLeft stroke="#444"></ArrowLeft>
        </router-link>

        <button
          v-if="requestStatus === null"
          class="btn btn-primary"
          style="width: 125px;"
          disabled
          @click="request"
        >
          <div
            class="spinner-border spinner-border-sm text-light"
            role="status"
          >
            <span class="sr-only">Loading...</span>
          </div>
        </button>

        <button
          v-if="requestStatus === 204"
          class="btn btn-primary"
          @click="request"
        >
          Request Access
        </button>

        <button
          v-else-if="requestStatus === 201"
          class="btn btn-primary"
          disabled
          @click="request"
        >
          Request Pending
        </button>

        <button
          v-else-if="requestStatus === 202"
          class="btn btn-success"
          disabled
          @click="request"
        >
          Request Accepted
        </button>

        <button
          v-else-if="requestStatus > 299"
          class="btn btn-danger"
          disabled
          @click="request"
        >
          Error
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import EnvBadge from "../components/EnvBadge"
import ArrowLeft from "../assets/arrow-left.svg"
export default {
  components: {
    ArrowLeft,
    EnvBadge,
  },
  props: {
    clientId: { required: true, type: String },
    apps: { required: true, type: Array },
    fetchApps: { required: true, type: Function },
  },
  data() {
    return {
      requestStatus: null,
    }
  },
  computed: {
    app() {
      return this.apps.find(({ cognito_id }) => cognito_id === this.clientId)
    },
  },
  async beforeMount() {
    if (!this.app) await this.fetchOrCreateApp()
    this.getStatus()
  },
  methods: {
    async fetchOrCreateApp() {
      // Trigger app creation, if it exists in Cognito
      const [_error, _response] = await this.$api.get(`/apps/${this.clientId}`)
      await this.fetchApps()
    },
    async request() {
      this.requestStatus = null
      const [_error, response] = await this.$api.post(
        `/request/${this.clientId}`,
      )
      if (response) {
        this.requestStatus = response.status
        await this.fetchApps()
      }
    },
    async getStatus() {
      const [_error, response] = await this.$api.get(
        `/request/${this.clientId}`,
      )
      if (response) {
        this.requestStatus = response.status
      }
    },
  },
}
</script>
